(function () {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('ConfigDetailController', ConfigDetailController);

    ConfigDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Config'];

    function ConfigDetailController($scope, $rootScope, $stateParams, previousState, entity, Config) {
        var vm = this;

        vm.config = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('bozorakaAdminApp:configUpdate', function (event, result) {
            vm.config = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
